import { TinyColor } from '@ctrl/tinycolor';
import { LINK_AND_HASHTAG_COLOR, POST_TEXT_COLOR, POST_TITLE_COLOR, } from '../../../constants/wix-params';
import { getPresetColor, getSiteColor } from '../../../services/colors';
export const getTextColorSchema = ({ appSettings, isMultipleColorsFixEnabled, }) => {
    const colors = [
        getSiteColor(appSettings, {
            wixParam: POST_TEXT_COLOR,
            presetFallback: 'color-5',
            colorFallback: '#00000',
        }),
        getSiteColor(appSettings, {
            wixParam: POST_TITLE_COLOR,
            presetFallback: 'color-5',
            colorFallback: '#00000',
        }),
        getSiteColor(appSettings, {
            wixParam: LINK_AND_HASHTAG_COLOR,
            presetFallback: 'color-8',
            colorFallback: '#00000',
        }),
        getPresetColor(appSettings, 'color-13'),
        getPresetColor(appSettings, 'color-18'),
        getPresetColor(appSettings, 'color-23'),
    ].filter((color) => Boolean(color));
    const hexColors = colors.map(toHexColor);
    const colorsToUse = isMultipleColorsFixEnabled
        ? [...new Set(hexColors)]
        : hexColors;
    return Object.fromEntries(colorsToUse.map((color, index) => [`textColor${index}`, { color, index }]));
};
export const getButtonColors = (appSettings) => {
    // colors used for ricos button templates
    const colors = {
        color1: getPresetColor(appSettings, 'color-1'),
        color7: getPresetColor(appSettings, 'color-7'),
        color8: getPresetColor(appSettings, 'color-8'),
    };
    return colors;
};
export const mergeUserAndSiteColors = (userColors, colorSchema) => {
    const siteColors = Object.values(colorSchema);
    return [...siteColors, ...userColors].filter(Boolean);
};
const toHexColor = (color) => new TinyColor(color).toHexString();
export const styleSelectionPredicate = (colorScheme, richContent) => (inlineStyle) => (colorScheme[inlineStyle] &&
    richContent.isHexColor(colorScheme[inlineStyle].color)) ||
    richContent.isHexColor(inlineStyle);
export const viewerCustomStyleFn = (colorScheme, richContent) => (inlineStyle) => {
    if (colorScheme[inlineStyle] &&
        richContent.isHexColor(colorScheme[inlineStyle].color)) {
        return { color: colorScheme[inlineStyle].color };
    }
    if (richContent.isHexColor(inlineStyle)) {
        return { color: inlineStyle };
    }
    return {};
};
export const customStyleFn = (viewerCustomStyleCallback, richContent) => (inlineStyles) => inlineStyles.toArray().reduce((acc, inlineStyle) => ({
    ...acc,
    ...viewerCustomStyleCallback(inlineStyle, richContent),
}), {});
export const viewerCustomBackgroundStyleFn = (colorScheme, richContent) => (inlineStyle) => {
    const userColor = colorScheme?.[inlineStyle]?.color;
    if (richContent.isHexColor(userColor)) {
        return { backgroundColor: userColor };
    }
    if (richContent.isHexColor(inlineStyle)) {
        return { backgroundColor: inlineStyle };
    }
    return {};
};
//# sourceMappingURL=text-color-utils.js.map